import { render, staticRenderFns } from "./MedicalAdvice.vue?vue&type=template&id=5b8da5fc"
import script from "./MedicalAdvice.vue?vue&type=script&lang=js"
export * from "./MedicalAdvice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports